export default __webpack_public_path__ + "static/insights-8aab08bef01cb80350a7ce4582349463.mp4";